export const seo = {
  top: {
      title: `Home`,
      description: `This blog is the personal blog of engineer Rhapsodist. It's always a place to learn new things and share that information with everyone. It deals with many kinds of new knowledge that are not limited to engineering.`,
      keyword: `rhapsodist, blog, development, IT, web, creativity, engineer, information, developer, knowledge, new, share, engineering, 음유시인, 블로그, 개발자, 창의적, 창의력, 정보, 지식, 개발`,
      canonical: `https://rhapsodist-blog.netlify.com`,
  },
  about: {
      title: `About`,
      description: `The about page is an introduction to Rhapsodist. It contains rhapsodist information such as basic information, career, education, language and hobbies. I am also using it for my personal resume or portfolio.`,
      keyword: `rhapsodist, blog, development, about, IT, web, introduction, career, education, language, hobby, resume, portfolio, 음유시인, 블로그, 소개, 이력, 교육, 언어, 취미, 이력서, 포트폴리오, 개발`,
      canonical: `https://rhapsodist-blog.netlify.com/about`
  },
  blogs: {
      title: `Blog Index`,
      description: `A blog page is a space shared when new information is written. Introduction pages about IT, web development, experiences, analysis / design, useful web services or many hobbies.`,
      keyword: `rhapsodist, blog, development, index, IT, web, development, experiences, analysis, design, services, hobbies, 웹개발, 경험담, 분석/설계, 유용한 웹 서비스, 취미 생활, 개발`,
      canonical: `https://rhapsodist-blog.netlify.com/blogs`
  },
  contact: {
      title: `Contact`,
      description: `The contact page lets you send a message to Rhapsodist. You can make a good relationship with Rhapsodist by contacting us with work requests, questions and comments.`,
      keyword: `rhapsodist, blog, contact, development, work, request, question, comment, relationship, message, send, 일 의뢰, 질문, 의견, 연락, 좋은 인연, 개발`,
      canonical: `https://rhapsodist-blog.netlify.com/contact`
  }
}